// @core/api/endpoints/booking/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AcceptWaitlistOffer } from './accept_waitlist_offer';
import { CancelBooking } from './cancel_booking';
import { CheckBookingAvailability } from './check_booking_availability';
import { CompleteBooking } from './complete_booking';
import { ConfirmBooking } from './confirm_booking';
import { CreateBooking } from './create_booking';
import { CreateBookingNumberingScheme } from './create_booking_numbering_scheme';
import { CreateResource } from './create_resource';
import { CreateReview } from './create_review';
import { DeleteBookingNumberingScheme } from './delete_booking_numbering_scheme';
import { DeleteBookingType } from './delete_booking_type';
import { DeleteResource } from './delete_resource';
import { GetAvailableSlots } from './get_available_slots';
import { GetBooking } from './get_booking';
import { GetBookingNumberingScheme } from './get_booking_numbering_scheme';
import { GetBookingType } from './get_booking_type';
import { GetEffectivePolicy } from './get_effective_policy';
import { GetResource } from './get_resource';
import { GetResourceStats } from './get_resource_stats';
import { JoinWaitlist } from './join_waitlist';
import { LeaveWaitlist } from './leave_waitlist';
import { ListBookingNumberingSchemes } from './list_booking_numbering_schemes';
import { ListBookingSchedule } from './list_booking_schedule';
import { ListBookingTypes } from './list_booking_types';
import { ListBookings } from './list_bookings';
import { ListMyBookings } from './list_my_bookings';
import { ListProviderBookings } from './list_provider_bookings';
import { ListResourceReviews } from './list_resource_reviews';
import { ListResources } from './list_resources';
import { ListWaitlistEntries } from './list_waitlist_entries';
import { MarkNoShow } from './mark_no_show';
import { RegisterBookingType } from './register_booking_type';
import { RejectBooking } from './reject_booking';
import { RescheduleBooking } from './reschedule_booking';
import { ResolveBookingContext } from './resolve_booking_context';
import { RespondToReview } from './respond_to_review';
import { SearchAvailableResources } from './search_available_resources';
import { SetResourceStatus } from './set_resource_status';
import { StartBooking } from './start_booking';
import { UpdateBookingNumberingScheme } from './update_booking_numbering_scheme';
import { UpdateBookingType } from './update_booking_type';
import { UpdateResource } from './update_resource';
import { UpsertPolicy } from './upsert_policy';

// Re-export individual endpoints
export {
  AcceptWaitlistOffer,
  CancelBooking,
  CheckBookingAvailability,
  CompleteBooking,
  ConfirmBooking,
  CreateBooking,
  CreateBookingNumberingScheme,
  CreateResource,
  CreateReview,
  DeleteBookingNumberingScheme,
  DeleteBookingType,
  DeleteResource,
  GetAvailableSlots,
  GetBooking,
  GetBookingNumberingScheme,
  GetBookingType,
  GetEffectivePolicy,
  GetResource,
  GetResourceStats,
  JoinWaitlist,
  LeaveWaitlist,
  ListBookingNumberingSchemes,
  ListBookingSchedule,
  ListBookingTypes,
  ListBookings,
  ListMyBookings,
  ListProviderBookings,
  ListResourceReviews,
  ListResources,
  ListWaitlistEntries,
  MarkNoShow,
  RegisterBookingType,
  RejectBooking,
  RescheduleBooking,
  ResolveBookingContext,
  RespondToReview,
  SearchAvailableResources,
  SetResourceStatus,
  StartBooking,
  UpdateBookingNumberingScheme,
  UpdateBookingType,
  UpdateResource,
  UpsertPolicy,
};

// Namespace export for convenient usage
export const bookingApi = {
  AcceptWaitlistOffer,
  CancelBooking,
  CheckBookingAvailability,
  CompleteBooking,
  ConfirmBooking,
  CreateBooking,
  CreateBookingNumberingScheme,
  CreateResource,
  CreateReview,
  DeleteBookingNumberingScheme,
  DeleteBookingType,
  DeleteResource,
  GetAvailableSlots,
  GetBooking,
  GetBookingNumberingScheme,
  GetBookingType,
  GetEffectivePolicy,
  GetResource,
  GetResourceStats,
  JoinWaitlist,
  LeaveWaitlist,
  ListBookingNumberingSchemes,
  ListBookingSchedule,
  ListBookingTypes,
  ListBookings,
  ListMyBookings,
  ListProviderBookings,
  ListResourceReviews,
  ListResources,
  ListWaitlistEntries,
  MarkNoShow,
  RegisterBookingType,
  RejectBooking,
  RescheduleBooking,
  ResolveBookingContext,
  RespondToReview,
  SearchAvailableResources,
  SetResourceStatus,
  StartBooking,
  UpdateBookingNumberingScheme,
  UpdateBookingType,
  UpdateResource,
  UpsertPolicy,
};
